import React, { useState, useEffect, useRef } from 'react';
import { calculatePrices, stripHtmlTags } from 'frontend/js/helpers';
import '../../sections/Popup/Popup.scss';

interface PopupProps {
  isOpen: boolean;
  setIsOpen: any;
  product: any;
  settings: any;
}

export function DosagePopup({ 
  product,
  settings,
  isOpen,
  setIsOpen
}: PopupProps) {

  const [prices, setPrices] = useState(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const klaviyo_form_dosage = settings?.globals?.klaviyo_form_dosage;
  const enable_klaviyo_form_dosage = settings?.globals?.enable_klaviyo_form_dosage;
  const dosage_form = stripHtmlTags(product?.dosage_form) || klaviyo_form_dosage;
  
    const closePopup = () => {
    setIsOpen(false);
    document.body.classList.remove('popup-active');
  };

  // Function to handle click outside popup
  const handleClickOutside = (e: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
      closePopup();
    }
  };

  // Function to handle Escape key press
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  };

  // Add event listeners for click outside and escape key
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  // Load product prices
  useEffect(() => {
    async function getPrices() {
      const pricesData = await calculatePrices(product);
      setPrices(pricesData);
    }

    getPrices();
  }, []);


  useEffect(() => {
    if (enable_klaviyo_form_dosage && dosage_form && isOpen) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', dosage_form]);
      const checkKlaviyoStatus = setInterval(() => {
        const klaviyoModal = document.querySelector('.klaviyo-form-modal');
        if (!klaviyoModal && isOpen) {
          setIsOpen(false);
          clearInterval(checkKlaviyoStatus);
        }
      }, 500);
      return () => clearInterval(checkKlaviyoStatus);
    }
  }, [enable_klaviyo_form_dosage, dosage_form, isOpen, setIsOpen]);

  if (enable_klaviyo_form_dosage && dosage_form && isOpen) {
    return null;
  }

  if (!isOpen) {
    return null;
  }

  // Render header block content
  const renderHeaderBlock = () => {
   
        const { globals: { logo } } = settings;

        return (
          <div className={`popup-header text-center max-w-[325px] lg:max-w-[400px] flex flex-col items-center mx-auto`}>
            {logo && (
              <img 
                src={logo} 
                alt={'Logo'} 
                className="popup-logo mx-auto mb-4 w-[95px]"
              />
            )}
            
          
            <div className={'popup-header__dosage-title h2 '}>
            {product.title} Dosage
            </div>
            
        
          </div>
        );
      };

  // Render disclaimer block
  const renderDisclaimerBlock = () => {
    
    return (
      <div className={`popup-dosage-guide b5 my-11 text-center`}>
        <div dangerouslySetInnerHTML={{ __html: product?.dosage }} />
      </div>
    );
  };

  const isAvailable = product?.variants[0]?.available;

  const variantFirstId = product?.variants[0]?.id || product?.id;

  return (
    <div 
      className={`popup-container fixed inset-0 z-50 flex items-center justify-center ${isOpen ? 'block' : 'hidden'}`}
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div 
        className="popup-overlay fixed inset-0 bg-black transition-opacity"
        style={{ opacity: 0.5 }}
      ></div>
      
      {/* Popup Content */}
      <div 
        ref={popupRef} 
        className={`popup-content relative bg-white rounded-[32px] z-50 shadow-lg overflow-hidden max-w-4xl max-h-[90dvh] mx-4 sm:mx-auto animate-fade-in w-[80vw]`}
        style={{ backgroundColor: `rgba(255, 255, 255, 0.90)` }}
      >
        {/* Close Button */}
        <button
          onClick={closePopup}
          className={`popup-close-btn absolute top-4 left-4 bg-black text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-gray-800 focus:outline-none z-10`}
          aria-label="Close popup"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>


        <div className="md:flex ">
          {/* Content wrapper */}
          <div className="popup-content-wrapper py-[100px] px-4 md:flex-1 ">
            {renderHeaderBlock()}
            {renderDisclaimerBlock()}
            <ajax-cart-product-form class='mx-auto'>
            <form
              action='/cart/add'
              id='product_form_id'
              className='product-form mx-auto flex'
              noValidate
              data-prodify-product-form
            >
              <input type="hidden" name="id" value={`${variantFirstId}`} />

              {isAvailable 
                ? <button onClick={() => {
                    setTimeout(() => setIsOpen(false), 100); 
                  }} className={`button button-primary w-[400px] mx-auto !p-6`}> {`${prices?.productPrice ? `${prices?.productPrice} | Buy Now` : 'Buy Now'}` }  </button>
                : <button className={`button button-tertiary w-[400px] mx-auto !p-6`} disabled>Out of stock</button>
              }
              
              <div
                data-ajax-cart-errors='form'
                className='text-xs text-error-1 mt-2'
              ></div>

            
            </form>
          </ajax-cart-product-form>

          </div>

        </div>
      </div>
    </div>
  );
}

export default DosagePopup;